import React from 'react'
import cx from 'classnames'
import { Switch, Route, Redirect, useLocation } from 'react-router-dom'
// creates a beautiful scrollbar
import PerfectScrollbar from 'perfect-scrollbar'
import 'perfect-scrollbar/css/perfect-scrollbar.css'
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
// core components
import AdminNavbar from '../components/AtlasNavbar/AtlasNavbar.js'
import Sidebar from '../components/Sidebar/AtlasSidebar.js'
import AtlasModal from '../components/AtlasModal/AtlasModal.js'

import { routes, RouteDisplay } from '../routes.js'

import styles from '../assets/jss/material-dashboard-pro-react/layouts/adminStyle.js'
import { dashboardResponse, maskOrgResponse } from './Aws.js'

// import awsconfig from "../aws-exports";
import { AmplifyAuthContainer, AmplifyAuthenticator, AmplifySignUp, AmplifySignIn } from '@aws-amplify/ui-react'
import { AuthState, onAuthUIStateChange } from '@aws-amplify/ui-components'

import logo from '../assets/img/whiteImages/ShopMateLogo.png'
import logoText from '../assets/img/whiteImages/RDPLogo.png'

export const AppContext = React.createContext('')

let ps

const useStyles = makeStyles(styles)

function App ({ ...rest }) {
  const [mobileOpen, setMobileOpen] = React.useState(false)
  const [miniActive, setMiniActive] = React.useState(true)
  const [isRdpUser, setRdpUser] = React.useState(false)

  const [filteredRoutes, setFilteredRoutes] = React.useState([])
  const [routesToDisplay, setRoutesToDisplay] = React.useState(0)

  const [pageTitle, setPageTitle] = React.useState('')

  // we pass the filteredRoutes to the sidebar for display, but we keep the unfiltered routes in place for the Switch below.
  // this is because otherwise, if you try and navigate to a route BEFORE the filter has run, it will simply fallback to /app/dashboard.
  // This does mean we can't use this method currently for security as if you know the route, you can simply type it into the url even if the links not present
  // This should definitely be improved - I've raised a ticket: AT-156
  React.useEffect(() => {
    const newFilteredRoutes = routes.filter((route) => {
      return (route.display & routesToDisplay)
    })

    setFilteredRoutes(newFilteredRoutes)
  }, [routesToDisplay])

  const switchRoutes = (
    <Switch>
      {routes.map((prop, key) => {
        if (prop.layout === '/app') {
          return (
            <Route
              path={prop.layout + prop.path}
              component={prop.component}
              key={key}
            />
          )
        }
        return null
      })}
      <Redirect from="/app" to="/app/dashboard" />
    </Switch>
  )

  const location = useLocation()

  React.useEffect(() => {
    for (const route of routes) {
      if (route.layout + route.path === location.pathname) {
        setPageTitle(route.name)

        continue
      }
    }
  }, [location])

  // styles
  const classes = useStyles()

  const mainPanelClasses =
    classes.mainPanel +
    ' ' +
    cx({
      [classes.mainPanelSidebarMini]: miniActive,
      [classes.mainPanelWithPerfectScrollbar]:
        navigator.platform.indexOf('Win') > -1
    })

  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef()

  // states and functions
  const [image] = ' '
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }

  const sidebarMinimize = () => {
    setMiniActive(!miniActive)
  }

  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false)
    } else if (miniActive) {
      setMiniActive(false)
    }
  }

  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
    if (window.innerWidth < 960) {
      setMiniActive(false)
    }
    if (navigator.platform.indexOf('Win') > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false
      })
      document.body.style.overflow = 'hidden'
    }
    window.addEventListener('resize', resizeFunction)
    // Specify how to clean up after this effect:
    return function cleanup () {
      if (navigator.platform.indexOf('Win') > -1) {
        ps.destroy()
      }
      window.removeEventListener('resize', resizeFunction)
    }
  }, [mainPanel])

  const reloadWindow = () => {
    window.location.reload()
  }

  const getDashboardResponse = () => {
    dashboardResponse().then(res => {
      setOrgName(res.orgName)
      setRdpUser(res.rdpUser)

      let newRoutesToDisplay = 0

      for (const site of res.sites) {
        if (site.code === 'H') {
          newRoutesToDisplay |= RouteDisplay.Hyperion
        } else if (site.code === 'S') {
          newRoutesToDisplay |= RouteDisplay.ShopMate
        } else if (site.code === 'A') {
          newRoutesToDisplay |= RouteDisplay.Atlas
        }
      }

      setRoutesToDisplay(newRoutesToDisplay)
    })
  }
  // load org name into navbar
  const [orgName, setOrgName] = React.useState('---')

  React.useEffect(() => {
    getDashboardResponse()
  }, [])

  React.useEffect(() => {
  }, [orgName])

  const [modalOpen, setModalOpen] = React.useState(false)

  const navBarCallback = () => {
    setModalOpen(true)
  }

  const closeModal = () => {
    setModalOpen(false)
  }

  const formData = {
    ShopID: {
      value: '',
      validator: /^[0-9\b]{4}$/,
      placeholderText: 'Shop ID'
    }
  }

  const maskAsOrg = async (data) => {
    setModalOpen(false)

    const bodyData = {
      payload: {
        shopID: data.ShopID.value
      }
    }

    const response = await maskOrgResponse(bodyData)

    return response
  }

  return (
    <div className={classes.wrapper}>
      <Sidebar
        routes={filteredRoutes}
        logoImg={logoText}
        logo={logo}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={'red'}
        bgColor={'rdp'}
        miniActive={miniActive}
        {...rest}
      />
      <div className={mainPanelClasses} ref={mainPanel}>
        <AdminNavbar
          sidebarMinimize={sidebarMinimize.bind(this)}
          miniActive={miniActive}
          routes={routes}
          handleDrawerToggle={handleDrawerToggle}
          brandText={pageTitle}
          orgName={orgName}
          isRdpUser={isRdpUser}
          appCallback={navBarCallback}
          {...rest}
        />
        <div className={classes.content} style={{ padding: '0px' }}>
          <div className={classes.container}>
            {switchRoutes}
          </div>
        </div>
      </div>
      <div id="app-modal">
        <AtlasModal
          title='Input the Shop ID'
          modalOpen={modalOpen}
          useBtnClose={false}
          dialogContentType='form'
          dialogFormProps={formData}
          dialogFormOnSubmit={maskAsOrg}
          callback={reloadWindow}
          onClose={closeModal}/>
      </div>
    </div>
  )
}

export default function AuthWrapper () {
  const [authState, setAuthState] = React.useState()
  const [user, setUser] = React.useState()

  React.useEffect(() => {
    return onAuthUIStateChange((nextAuthState, authData) => {
      setAuthState(nextAuthState)
      setUser(authData)
    })
  }, [])

  return authState === AuthState.SignedIn && user ? (
    <App></App>
  ) : (
    <AmplifyAuthContainer>
      <AmplifyAuthenticator usernameAlias="email">
        <AmplifySignUp
          slot="sign-up"
          usernameAlias="email"
          formFields={[
            {
              type: 'email',
              label: 'Email Address *',
              placeholder: 'Enter your email address'
            },
            {
              type: 'password',
              label: 'Password *',
              placeholder: 'Enter your password'
            }
          ]}
        />
        <AmplifySignIn
          slot="sign-in"
          usernameAlias="email"
          formFields={[
            {
              type: 'email',
              label: 'Email Address *',
              placeholder: 'Enter your email address'
            },
            {
              type: 'password',
              label: 'Password *',
              placeholder: 'Enter your password'
            }
          ]}
        />
      </AmplifyAuthenticator>
    </AmplifyAuthContainer>
  )
}

// const amplifyTheme = {
//   button: { backgroundColor: primaryColor[0], borderColor: primaryColor[0] },
//   a: { color: primaryColor[0] }
// }

// export default withAuthenticator(App, false, [], null, amplifyTheme, {
//   hiddenDefaults: ['phone_number', 'username'],
//   usernameAlias: "email"
// })

// export default withAuthenticator(App, {
//   // Render a sign out button once logged in
//   includeGreetings: true,
//   // Show only certain components
//   authenticatorComponents: [MyComponents],
//   // display federation/social provider buttons
//   federated: {myFederatedConfig},
//   // customize the UI/styling
//   theme: {styles}});
